/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest,
  PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
  PostApiV1ExamQuestionLibraryAiCorrection400,
  PostApiV1ExamQuestionLibraryAiCorrection401,
  PostApiV1ExamQuestionLibraryAiCorrection500,
} from "../../types/examQuestionLibraryController/PostApiV1ExamQuestionLibraryAiCorrection.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1ExamQuestionLibraryAiCorrectionUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/exam/question-library/ai-correction` as const,
  };
  return res;
}

/**
 * @description Revisa uma questão na biblioteca de questões utilizando inteligência artificial. O tipo do componente determina quais campos são obrigatórios e qual estratégia de revisão é aplicada.
 * Para questões **MultilineText com subtipo**, a IA aplica critérios específicos por subtipo:
 * - **OpinionArticle** (1): avalia se o enunciado propõe tema debatível, convida ao posicionamento e tem escopo adequado.
 * - **Essay** (2): avalia clareza, nível cognitivo, aderência ao conteúdo e ausência de ambiguidade.
 * - **ModelAnswerEssay** (3): revisa enunciado, resposta-modelo e termos-chave. Requer `modelAnswer`.
 * - **MbaCase** (4): revisa enunciado e Notas de Ensino (gabarito técnico). Requer `modelAnswer`.
 * Para questões de lista (SingleChoice ou MultipleChoice), informe as alternativas no campo `ExamTypeList`. **(Requer Authorization para autenticação)**
 * @summary Revisão de questão com AI (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/ai-correction}
 */
export async function postApiV1ExamQuestionLibraryAiCorrection(
  data: PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryAiCorrection400
      | PostApiV1ExamQuestionLibraryAiCorrection401
      | PostApiV1ExamQuestionLibraryAiCorrection500
    >,
    PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamQuestionLibraryAiCorrectionUrl().url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
